import { $ } from "@/common/Axios";

export default {
  /**
   * 成考空报
   */
  adultExamEmpty: {
    /*
     * 添加
     * address 通知书邮寄地址 (string query )
     * applyStatus 报名状态 (string query )
     * discipline 科类 (string query )
     * education 最高学历 (string query )
     * enrollId 报名人id (integer query )
     * feeStatus 缴费状态 (string query )
     * id  (integer query )
     * idCardNo 身份证号码 (string query )
     * level 层次 (string query )
     * major 专业 (string query )
     * majorCode 专业代码 (string query )
     * name 姓名 (string query )
     * nation 民族 (string query )
     * photo 个人照 (string query )
     * remark 备注 (string query )
     * site 学校 (string query )
     * siteCode 学校代码 (string query )
     * supply 提供人 (string query )
     * supplyId 提供人 (integer query )
     * year 成考年度 (string query )
     */
    post: (p, c) => $.post("/api/ems/adultexam/adultExamEmpty", p, c),
  },
  adultExamEmpty_assignEnroll: {
    /*
     * 分配报名人
     * enrollId 报名人id (integer query required)
     * ids 空报id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/adultExamEmpty/assignEnroll", p, c),
  },
  adultExamEmpty_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamEmpty/export", p, c),
  },
  adultExamEmpty_getApplyInfo: {
    /*
     * 获取报名信息（报名辅助页面）
     * idCardNo 身份证号码 (string query required)
     * year 成考年度 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/adultExamEmpty/getApplyInfo", p, c),
  },
  adultExamEmpty_list: {
    /*
     * 空报列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamEmpty/list", p, c),
  },
  adultExamEmpty_listForInner: {
    /*
     * 空报列表-内部管理
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/adultExamEmpty/listForInner", p, c),
  },
  adultExamEmpty_remark: {
    /*
     * 备注
     * id 空报id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/ems/adultexam/adultExamEmpty/remark", p, c),
  },
  adultExamEmpty_updatePhoto: {
    /*
     * 批量导入更新个人照（身份证命名）
     * idCardNo 身份证 (string query required)
     * photo 照片地址 (string query required)
     * year 成考年度 (string query required)
     */
    put: (p, c) => $.put("/api/ems/adultexam/adultExamEmpty/updatePhoto", p, c),
  },
  adultExamEmpty_updateStatus: {
    /*
     * 报名人编辑状态（缴费状态或报名状态）
     * id 空报id (integer query required)
     * status 状态 (string query required)
     * type 类型：缴费状态或报名状态 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/adultExamEmpty/updateStatus", p, c),
  },
  adultExamEmpty_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/adultExamEmpty/upload", p, c),
  },

  /**
   * 成考专业代码
   */
  adultExamMajorCode: {
    /*
     * 添加
     * area 成考考区 (string query )
     * colPcode 学校代码 (string query )
     * colTitle colTitle (string query )
     * colYear 成考年度 (string query )
     * discipline 科类 (string query )
     * id  (integer query )
     * majorCode 专业代码 (string query )
     * majorId 专业id (integer query )
     * originContent 原文内容 (string query )
     * owid owid (string query )
     * selfFlag 是否自己函授站 (string query )
     * siteCode 院校代码 (string query )
     * year 成考年度 (string query )
     * zyPcode 专业代码 (string query )
     * zyTitle zyTitle (string query )
     */
    post: (p, c) => $.post("/api/ems/adultexam/adultExamMajorCode", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/adultexam/adultExamMajorCode", p, c),
  },
  adultExamMajorCode_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamMajorCode/export", p, c),
  },
  adultExamMajorCode_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamMajorCode/list", p, c),
  },
  adultExamMajorCode_updateInfo: {
    /*
     * 更新考试院招生计划中的信息
     * file Json文件路径 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/adultExamMajorCode/updateInfo", p, c),
  },
  adultExamMajorCode_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/adultExamMajorCode/upload", p, c),
  },

  /**
   * 成考官方信息
   */
  officialInfo_restore: {
    /*
     * 修复
     * feeStatus 缴费状态 (string query required)
     * noTrial 是否免试 (string query required)
     * owid owid (string query required)
     * state 审核状态 (string query required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/officialInfo/restore", p, c),
  },
  officialInfo_saveEnrollInfo: {
    /*
     * 保存报考信息
     * denyReason 拒绝理由 (string query )
     * denyTimes 拒绝次数 (string query )
     * feeStatus 缴费状态 (string query required)
     * foreignTitle 语种 (string query )
     * idCardNo 身份证号 (string query )
     * owid owid (string query )
     * signType 登陆类型：1：正常,2免试 (string query )
     * state 状态 (string query required)
     * zyOwid 专业 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/officialInfo/saveEnrollInfo", p, c),
  },
  officialInfo_saveSignInfo: {
    /*
     * 保存考试院信息
     * idCardNo 身份证号 (string query required)
     * name 姓名 (string query required)
     * nation 民族 (string query required)
     * owid 用户id (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/officialInfo/saveSignInfo", p, c),
  },
  officialInfo_uploadAdmission: {
    /*
     * 上传录取名单
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/officialInfo/uploadAdmission", p, c),
  },

  /**
   * 分数线
   */
  scoreLine: {
    /*
     * 添加
     * discipline 科类 (string query )
     * id  (integer query )
     * level 层次 (string query )
     * majorId 专业ID，华博特分数线用 (integer query )
     * score 分数线 (integer query )
     * type 类型：浙江省分数线|华博特分数线 (string query )
     * year 成考年度 (string query )
     */
    post: (p, c) => $.post("/api/ems/adultexam/scoreLine", p, c),
  },
  scoreLine_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/scoreLine/export", p, c),
  },
  scoreLine_listPage: {
    /*
     * 分数线列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/scoreLine/listPage", p, c),
  },
  scoreLine_syncHbtLowestScore: {
    /*
     * 测试-同步华博特内部学生最低分数线
     * year 成考年度 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/scoreLine/syncHbtLowestScore", p, c),
  },

  /**
   * 成考信息
   */
  studentAdultExamInfo_assignAdminTeacher: {
    /*
     * 分配合同负责人
     * newAdminId 负责人 (integer query required)
     * schoolRollId 合同编号 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/assignAdminTeacher", p, c),
  },
  studentAdultExamInfo_confirmInfo: {
    /*
     * 确认学生资料
     * id 学生资料id (integer query required)
     * refuseReason 拒绝理由 (string query )
     * status 通过1,拒绝0 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/confirmInfo", p, c),
  },
  studentAdultExamInfo_detail: {
    /*
     * 学生资料详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/detail", p, c),
  },
  studentAdultExamInfo_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/downloadMould", p, c),
  },
  studentAdultExamInfo_enrollHelperDetail: {
    /*
     * 报名辅助页面
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/enrollHelperDetail", p, c),
  },
  studentAdultExamInfo_examIdCard: {
    /*
     * 准考证信息
     * examAddress 考试地址 (string query required)
     * examArea 考点 (string query required)
     * examIdCard 准考证 (string query required)
     * examIdCardNo 准考证号 (string query required)
     * idCardNo 身份证号 (string query required)
     * name 姓名 (string query required)
     * year 成考年度 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/examIdCard", p, c),
  },
  studentAdultExamInfo_export: {
    /*
     * 学历教育-成考管理-学生资料导出
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/export", p, c),
  },
  studentAdultExamInfo_exportForEnrollTeacher: {
    /*
     * 招生管理-成考学生（招生老师角度）-导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/adultexam/studentAdultExamInfo/exportForEnrollTeacher",
        p,
        c
      ),
  },
  studentAdultExamInfo_exportForPeer: {
    /*
     * 基础平台-同行管理-成考学生导出
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/exportForPeer", p, c),
  },
  studentAdultExamInfo_exportForTotal: {
    /*
     * 成考统计-下载(是否包含往届生选择是的时候,点总数下载)
     * businessDepartmentIds 服务事业部 (array query )
     * departmentId 服务部门 (integer query )
     * enrollDepartmentIds 招生部门 (array query )
     * previousFlag 是否往届生(全部、是、否, 选是否的时候下载) (string query required)
     * province 学校省份 (string query )
     * step 阶段 (string query )
     * year 成考年度（列表选择） (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/exportForTotal", p, c),
  },
  studentAdultExamInfo_getAdultExamShowInfoForApp: {
    /*
     * 成考宝典-我的成考信息
     * month 月份 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/adultexam/studentAdultExamInfo/getAdultExamShowInfoForApp",
        p,
        c
      ),
  },
  studentAdultExamInfo_list: {
    /*
     * 学历教育-成考管理-学生资料列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/studentAdultExamInfo/list", p, c),
  },
  studentAdultExamInfo_listForEnrollTeacher: {
    /*
     * 招生管理-成考学生（招生老师角度）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/adultexam/studentAdultExamInfo/listForEnrollTeacher",
        p,
        c
      ),
  },
  studentAdultExamInfo_listForPeer: {
    /*
     * 基础平台-同行管理-成考学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listForPeer", p, c),
  },
  studentAdultExamInfo_listForRedeem: {
    /*
     * 待挽回列表
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listForRedeem", p, c),
  },
  studentAdultExamInfo_listStatics: {
    /*
     * 成考统计-列表顶部统计
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listStatics", p, c),
  },
  studentAdultExamInfo_listTotalData: {
    /*
     * 成考统计-列表
     * businessDepartmentIds 服务事业部 (array query )
     * departmentId 服务部门 (integer query )
     * enrollDepartmentIds 招生部门 (array query )
     * previousFlag 是否往届生(全部、是、否, 选是否的时候下载) (string query required)
     * province 学校省份 (string query )
     * year 成考年度（列表选择） (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listTotalData", p, c),
  },
  studentAdultExamInfo_passByFeeImage: {
    /*
     * 缴费通过
     * feeImage 缴费截图 (string query required)
     * idCardNo 身份证号 (string query required)
     * year 成考年度 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/passByFeeImage", p, c),
  },
  studentAdultExamInfo_updateInfo: {
    /*
     * 编辑学生资料
     * addScoreItem 加分类型 (string query )
     * addScoreItemContent 加分附件 (string query )
     * area 成考考区 (string query )
     * city 地级市 (string query )
     * id 列表id (integer query required)
     * localContent 成考外地凭证内容，类型为本地时不填，为社保、居住证时候上传截图，三无时填写备注 (string query )
     * localType 成考所在地类型:未知、本地、社保、居住证、三无 (string query )
     * notNeedExamItem 免试类型 (string query )
     * notNeedExamItemContent 免试附件 (string query )
     * remark 成考备注 (string query )
     * shippingAddress 收件地址 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/updateInfo", p, c),
  },
  studentAdultExamInfo_updateItemContent: {
    /*
     * 编辑加分附件或免试附件（本地批量选择文件夹导入，命名方式合同编号）
     * idCardNo 身份证号 (string query required)
     * itemContent 附件地址 (string query required)
     * type 类型：加分附件或免试附件 (undefined body required)
     * year 成考年度 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/updateItemContent", p, c),
  },
  studentAdultExamInfo_updateLocalContent: {
    /*
     * 批量导入更新社保或居住证
     * idCardNo 身份证 (undefined body required)
     * url 图片地址 (undefined body required)
     * year 成考年度 (undefined body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/adultexam/studentAdultExamInfo/updateLocalContent",
        p,
        c
      ),
  },
  studentAdultExamInfo_uploadCodeForTransfer: {
    /*
     * 导入成考报名转专业
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/adultexam/studentAdultExamInfo/uploadCodeForTransfer",
        p,
        c
      ),
  },
  studentAdultExamInfo_uploadStudentInfo: {
    /*
     * 导入学生资料
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/studentAdultExamInfo/uploadStudentInfo", p, c),
  },

  /**
   * 学生分数
   */
  studentOfficeScore_list: {
    /*
     * 成绩列表
     * idCardNo 身份证 (string query required)
     * year 成考年度 (string query required)
     */
    get: (p, c) => $.get("/api/ems/adultexam/studentOfficeScore/list", p, c),
  },
  studentOfficeScore_saveScore: {
    /*
     * 保存成绩
     * subjectGrades 课程成绩 (array query required)
     * subjectTitles 课程名称 (array query required)
     * userName 姓名 (string query required)
     * zkzh 准考证号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentOfficeScore/saveScore", p, c),
  },
  studentOfficeScore_uploadScore: {
    /*
     * 上传成绩
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/studentOfficeScore/uploadScore", p, c),
  },

  /**
   * 志愿调整
   */
  volunteerTransfer: {
    /*
     * 添加
     * agreeType 是否愿意接受调剂 (string query )
     * id  (integer query )
     * idCardNo 身份证 (string query )
     * level 层次 (string query )
     * major 专业 (string query )
     * majorCode 专业代码 (string query )
     * officeMajor 考试院专业 (string query )
     * officeMajorCode 考试院专业代码 (string query )
     * officeSite 考试院院学校 (string query )
     * officeSiteCode 考试院学校代码 (string query )
     * remark 备注 (string query )
     * site 学校 (string query )
     * siteCode 学校代码 (string query )
     * status 状态：调剂中，调剂错误，已调剂 (string query )
     * type 类型 (string query )
     * year 成考年度 (string query )
     */
    post: (p, c) => $.post("/api/ems/adultexam/volunteerTransfer", p, c),
  },
  volunteerTransfer_agree: {
    /*
     * 是否同意
     * agreeType 是否统一 (string query required)
     * id id (integer query required)
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/ems/adultexam/volunteerTransfer/agree", p, c),
  },
  volunteerTransfer_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/volunteerTransfer/export", p, c),
  },
  volunteerTransfer_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/volunteerTransfer/list", p, c),
  },
  volunteerTransfer_listColumn: {
    /*
     * 字段列表
     * key key (string query required)
     * type 类型：调剂、补报 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/volunteerTransfer/listColumn", p, c),
  },
  volunteerTransfer_syncTransfers: {
    /*
     * 同步调剂(补报)
     * col1zy1RefOwid 专业代码id (string query required)
     * name 准考证号 (string query )
     * zkzh 准考证号 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/volunteerTransfer/syncTransfers", p, c),
  },
  volunteerTransfer_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/volunteerTransfer/upload", p, c),
  },
};
